import { FC, createContext, PropsWithChildren, useMemo, useContext } from "react";
import { ClientBFFClient } from "@finbackoffice/clientbff-client";
import { AxiosLikeErrorMiddleware } from "@finbackoffice/http-client";
import { AuthContext } from "./auth.provider";

export type IClientProviderProps = {
    client?: ClientBFFClient;
};

// @TODO handle capture exception

export const ClientBFFContext = createContext<ClientBFFClient>(null as any);

export const ClientProvider: FC<IClientProviderProps & PropsWithChildren> = ({
    children,
    client,
}) => {
    const { setToken } = useContext(AuthContext);

    const value = useMemo(() => {
        if (!client) {
            const origin =
                typeof window !== "undefined" && window.location.origin
                    ? window.location.origin
                    : "";

            return new ClientBFFClient(`${origin}/api/proxy/`, "sportsbook-mobile", [
                new AxiosLikeErrorMiddleware({
                    handleNotOkStatusCode(error, response) {
                        if (response.statusCode === 401) {
                            setToken("");
                        }
                    },
                }),
            ]);
        }

        return client;
    }, [client, setToken]);

    return <ClientBFFContext.Provider value={value}>{children}</ClientBFFContext.Provider>;
};
